import React from 'react';
import { useParams } from 'react-router-dom';
import '../print.css';

import { WorkOrderForm } from '../print-forms/work-order-form';
import { WorkProcessForm } from '../print-forms/work-process-form';

export function PrintWrapper(props) {
  const { page, id } = useParams();

  switch(page) {

    case 'order':
      return <WorkOrderForm />

    case 'process':
      return <WorkProcessForm />

    default:
      return (
        <table className="outer-main" border="1">
          <tbody>
            <tr>
              <td>
                {page}, {id}
              </td>
            </tr>
            <tr>
              <td>{props.children}</td>
            </tr>
          </tbody>
        </table>
      );
  }
}
